export function reducer(state, action) {
  switch (action.type) {
    case 'CurrentPage':
      return {
        ...state,
        ...action.payload,
      };
    case 'PopUP':
      return {
        ...state,
        popUp: action.payload,
      };
    case 'setLanguage': {
      return {
        ...state,
        language: action.payload,
      };
    }
    case 'setFilters': {
      return {
        ...state,
        filters: action.payload,
      };
    }
    case 'addFilter': {
      return {
        ...state,
        filters: [...state.filters, action.payload],
      };
    }
    case 'drawerState': {
      return {
        ...state,
        ...action.payload,
      };
    }
    case 'setFieldIdWhichWillBeUpdated': {
      return {
        ...state,
        ...action.payload,
      };
    }
    case 'emptyAdminInput': {
      return {
        ...state,
        idOfNewCourse: '',
        langDrawerVisibility: false,
        editDrawerVisibility: false,
        courseDrawerVisibility: false,
        builderDrawerVisibility: false,
        courseSubmitName: '',
        courseSubmitFaculty: '',
        langSelectedLangs: [],
        courseMaxStudentNumber: '',
        selectionPeriod: [],
        professionData: [],
        selectionPeriodEdit: [],
        selectionPeriodData: [],

        languageData: [],
        courseSelection: [],
        selectionDrawerVisibility: false,
        // langDrawerVisibility: false,
        // selectionDrawerVisibility: false,
        // langSubmitName: null,
        // langSubmitFaculty: null,
        // langMaxStudentNumber: null,
        // langSelectedLangs: [],
        // editDrawerVisibility: false,
        currentPage: 'ADMIN',
        init: false,
        newUserSubmitFirstName: '',
        newUserSubmitRoleId: undefined,
        newUserSubmitPassword: '',
        newUserSubmitLastName: '',
        newUserSubmitEmail: '',
        newUserSubmitPhone: '',
        newUserSubmitLogin: '',
        newUserSubmitGroup: ''
      };
    }
    case 'init': {
      return {
        ...state,
        ...action.payload,
      };
    }
    case 'setRole':
      return {
        ...state,
        role: action.payload,
      };
    case 'setUserGroups':
      return {
        ...state,
        userGroups: action.payload
      }
    default:
      return state;
  }
}
